<template>
  <div>
    <slot name="txtBefore"></slot>
    <div v-for="consent in editableConsents" :key="consent.consentType" :class="consent.name">
      <slot :name="`txtBeforeConsent${consent.name}`"></slot>
      <ConsentAccept :given-consent="consent" :channel-types="consent.channelTypes" @update:changedConsent="changedConsent">
        <template v-for="slot in possibleChildSlotsFor('Accept'+consent.name)" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </ConsentAccept>
      <slot :name="`txtAfterConsent${consent.name}`"></slot>
    </div>

    <slot name="txtAfterConsents"></slot>

    <div class="buttons">
      <button @click="saveConsentChanges" :disabled="loading"><slot name="btnSave"></slot></button>
    </div>

    <slot name="txtAfter"></slot>
  </div>
</template>

<script>
import processSteps from '@/mixins/processSteps'
import { stepName as nextStep } from '@/components/generic/Success.vue'
import ConsentAccept from '@/components/process/generic/Consent/ConsentAccept.vue'
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import { mapActions } from 'vuex'
import preFilledInput from '@/mixins/preFilledInput'
import transaction from '@/mixins/transaction'

export const stepName = 'change'

export default {
  name: 'ChangeConsentWrapper',
  components: { ConsentAccept },
  data () {
    return {
      customerConsents: {
        consents: [],
        consentTexts: []
      },
      loading: false
    }
  },
  mounted () {
    this.startLoader()
  },
  mixins: [
    processSteps(stepName, stepName, nextStep),
    preFilledInput('editableConsents', 'consents'),
    transaction('consent')

  ],
  apollo: {
    customerConsents: function () {
      return wrapQuery(
        gql`fragment Channel on AdChannel {
          adChannelType
          changeDate
          channel
          subChannel
          userId
        }
        query consent {
          customerConsents {
            consentTexts {
              name
              text
              version
              hash
            }
            consents {
              consentType
              selectedAdChannels {
                ...Channel
              }
              notSelectedAdChannels {
                 ...Channel
              }
            }
          }
        }`, this, 'customerConsents', {}, () => {
          this.stopLoader()

          // format consent text
          if (typeof window.consentTextFormatter === 'function') {
            for (let i = 0; i < this.customerConsents.consentTexts.length; i++) {
              this.customerConsents.consentTexts[i].text = window.consentTextFormatter(this.customerConsents.consentTexts[i].name, this.customerConsents.consentTexts[i].text)
            }
          }
        },
        {
          fetchPolicy: 'cache-first'
        },
        () => {
          this.stopLoader()
        }
      )
    }
  },
  methods: {
    ...mapActions('consent', [
      'changeConsent'
    ]),
    saveConsentChanges () {
      this.loading = true
      this.changeConsent({ changeConsentData: this.editableConsents, nextStep: nextStep }).then(() => {
        this.successToast(this.$slots.txtToastBEWSettingsSaved ? this.$slots.txtToastBEWSettingsSaved[0].text : 'Die Einstellung wurde erfolgreich gespeichert.')
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    changedConsent (changed) {
      this.editableConsents =
        (this.editableConsents || this.consents).map(consent => {
          if (consent.consentType === changed.consentType) {
            return changed
          }
          return consent
        })
    }
  },
  computed: {
    consents: function () {
      return this.filterConsents
        ?.map(configConsent => {
          return {
            ...configConsent,
            ...this.customerConsents.consentTexts.find(text => text.name === configConsent.name),
            ...this.customerConsents.consents.find(consent => consent.consentType === configConsent.consentType),
            selected: this.customerConsents.consents.find(consent => consent.consentType === configConsent.consentType) != null
          }
        })
    },
    contractTerms: function () {
      const t = this.customerConsents.consentTexts.find(item => item.name === 'contract_terms')?.text || ''
      if (typeof window.consentTextFormatter === 'function') {
        return window.consentTextFormatter('contract_terms', t)
      }

      return t
    }
  },
  props: {
    filterConsents: {
      type: Array,
      default: () => [{ consentType: 'BEW', explicit: false, name: 'name' }]
    }
  }
}
</script>
